import { jsx as _jsx } from "react/jsx-runtime";
const kebab = (token) => token.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
/**
 * All text in the product.
 *
 * Screens choose a step on the scale, not a size in pixels, which is the only
 * reason the eight-step scale stays eight steps.
 */
export function Text({ children, variant = 'body', tone = 'primary', align, truncate = false, numeric = false, as: Component = 'p', className, ...rest }) {
    const classes = [
        'lh-text',
        `lh-text--${kebab(variant)}`,
        `lh-text--${tone}`,
        align && `lh-text--${align}`,
        truncate && 'lh-truncate',
        numeric && 'lh-numeric',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Component, { className: classes, ...rest, children: children }));
}
//# sourceMappingURL=Text.js.map